import { render, staticRenderFns } from "./WidgetConfig.vue?vue&type=template&id=246dbe80&scoped=true"
import script from "./WidgetConfig.vue?vue&type=script&lang=js"
export * from "./WidgetConfig.vue?vue&type=script&lang=js"
import style0 from "./WidgetConfig.vue?vue&type=style&index=0&id=246dbe80&prod&lang=scss"
import style1 from "./WidgetConfig.vue?vue&type=style&index=1&id=246dbe80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246dbe80",
  null
  
)

export default component.exports